type Props = {
    color: string;
};

export const PMRIcon = ({ color }: Props) => (
    <svg id="SVGRoot" width="100%" height="100%" version="1.1" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg">
        <g>
            <rect fill={color} x="160" width="64" height="64" />
            <rect fill={color} x="128" y="32" width="128" height="64" />
            <rect fill={color} x="128" y="64" width="96" height="64" />
            <rect fill={color} x="128" y="96" width="64" height="96" />
            <rect fill={color} x="128" y="160" width="224" height="64" />
            <g>
                <rect fill={color} x="64" y="192" width="64" height="64" />
                <rect fill={color} x="64" y="416" width="64" height="64" />
                <rect fill={color} x="32" y="224" width="64" height="64" />
                <rect fill={color} x="32" y="384" width="64" height="64" />
                <rect fill={color} x="384" y="416" width="64" height="64" />
            </g>
            <rect fill={color} y="288" width="64" height="96" />
            <rect fill={color} x="128" y="448" width="128" height="64" />
            <g>
                <rect fill={color} x="256" y="416" width="32" height="64" />
                <rect fill={color} x="288" y="384" width="32" height="64" />
                <rect fill={color} x="352" y="352" width="32" height="64" />
                <rect fill={color} x="448" y="384" width="32" height="64" />
            </g>
            <rect fill={color} x="192" y="192" width="64" height="96" />
            <rect fill={color} x="192" y="256" width="160" height="64" />
            <rect fill={color} x="320" y="288" width="64" height="96" />
            <g>
                <rect fill={color} x="352" y="384" width="64" height="32" />
                <rect fill={color} x="96" y="448" width="64" height="32" />
                <rect fill={color} x="256" y="416" width="64" height="32" />
                <rect fill={color} x="448" y="384" width="64" height="32" />
                <rect fill={color} x="416" y="416" width="64" height="32" />
            </g>
            <rect fill={color} x="480" y="384" width="32" height="32" />
            <rect fill={color} x="96" y="192" width="64" height="32" />
            <rect fill={color} x="32" y="256" width="32" height="64" />
            <rect fill={color} x="32" y="352" width="32" height="64" />
        </g>
    </svg>
);
